import type { $Fetch } from 'ofetch';
import { useNuxtApp } from 'nuxt/app';

/**
 * Composable to access the API client in common runtime.
 * This should only be used in the common runtime context so typescript does not complain about unknown type when deconstructing from useNuxtApp.
 */
export function useApi() {
	const { $api } = useNuxtApp();

	return $api as $Fetch;
}
